import { flatten } from '@omnicomm/shared';
import { createInstance, type i18n, type Resource } from 'i18next';
import Backend, { type ChainedBackendOptions } from 'i18next-chained-backend';
import HttpApi, { type HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next/initReactI18next';

const isRunOnServer = typeof window === 'undefined';

export async function initTranslations(
  token?: string,
  locale = 'en',
  namespaces = ['localization', 'messages'],
  i18nInstance?: i18n,
  resources?: Resource,
) {
  if (!i18nInstance || typeof i18nInstance.use !== 'function') {
    i18nInstance = createInstance();
  }

  i18nInstance.use(initReactI18next);
  i18nInstance.use(Backend);

  const httpOption: HttpBackendOptions = {
    customHeaders: () => {
      if (token) {
        return {
          authorization: `JWT ${token}`,
        };
      }
      1;
      return {} as Record<string, string>;
    },
    parse: (data: string, _languages: Array<string>, ns: string) => {
      let parsed;
      try {
        parsed = JSON.parse(data)[0];
      } catch (e) {
        console.error('[i18n] JSON parse error', e);
        throw e;
      }

      let result;

      if (ns === 'localization' || ns === 'events' || ns === 'log') {
        result = flatten(parsed['language']);
      } else {
        result = flatten(parsed, { addBrackets: true });
      }

      return result;
    },

    loadPath: (lngs: string[], namespaces: string[]) => {
      const lng = lngs[0];
      const ns = namespaces[0];

      const url = `${isRunOnServer ? process.env.FES_HOST : '/'
        }service/localization/api/localization?project=ase&locale=${lng}&group=${ns}`;
      return url;
    },
    reloadInterval: false
  };

  let backends = [HttpApi];
  let backendOptions: any[] = [httpOption];

  if (isRunOnServer) {
    // const FsBackend = await import('i18next-fs-backend/cjs');

    // const fsBackendOption = {
    //   parse: (data: string) => {
    //     try {
    //       return flatten(JSON.parse(data));
    //     } catch (e) {
    //       console.error('[i18n] FS parse error', e);
    //       throw e;
    //     }
    //   },

    //   expirationTime: 3000 * 1000,

    //   loadPath: (lngs: string[], namespaces: string[]) => {
    //     const lng = Array.isArray(lngs) ? lngs[0] : lngs;
    //     const ns = Array.isArray(namespaces) ? namespaces[0] : namespaces;

    //     const path = `${process.env.LOCALES_FS_CACHE ?? './'}locales_cache/${lng}/${ns}_${extra}.json`;

    //     return path;
    //   },

    //   addPath: (lngs: string[], namespaces: string[]) => {
    //     const lng = Array.isArray(lngs) ? lngs[0] : lngs;
    //     const ns = Array.isArray(namespaces) ? namespaces[0] : namespaces;
    //     const path = `${process.env.LOCALES_FS_CACHE ?? './'}locales_cache/${lng}/${ns}_${extra}.json`;
    //     return path;
    //   },
    // };

    backends = [HttpApi];
    backendOptions = [httpOption];
  } else {
  }

  try {
    await i18nInstance.init<ChainedBackendOptions>({
      lng: locale,
      resources,
      supportedLngs: ['en', 'ru', 'fr', 'kz', 'vi', 'cn', 'sp', 'ch', 'pt'],
      defaultNS: namespaces[0],
      fallbackNS: namespaces[0],
      preload: false,
      ns: namespaces[0],
      partialBundledLanguages: true,
      backend: {
        backends,
        backendOptions,
      },
    });
  } catch (e) {
    console.error('[i18n] init FAILED', e);
    throw e;
  }

  return {
    i18n: i18nInstance,
    resources: {
      [locale]: i18nInstance.services.resourceStore.data[locale],
    },
    t: i18nInstance.t,
  };
}
